var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _vm.showGradient
        ? _c("path", {
            attrs: {
              d: "M3.62833 3.70771C2.11953 5.27491 2.42833 6.93971 2.42833 11.9973C2.42833 16.1973 1.69553 20.4077 5.53073 21.3989C6.72833 21.7069 17.3395 21.7069 18.5355 21.3973C20.1323 20.9853 21.4315 19.6901 21.6091 17.4317C21.6339 17.1165 21.6339 6.88371 21.6083 6.56211C21.4195 4.15651 19.9387 2.77011 17.9875 2.48931C17.5403 2.42451 17.4507 2.40531 15.1563 2.40131C7.01793 2.40531 5.23393 2.04291 3.62833 3.70771Z",
              fill: "url(#paint0_linear_1954_4435)",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showGradient
        ? _c("path", {
            attrs: {
              d: "M3.62833 3.70771C2.11953 5.27491 2.42833 6.93971 2.42833 11.9973C2.42833 16.1973 1.69553 20.4077 5.53073 21.3989C6.72833 21.7069 17.3395 21.7069 18.5355 21.3973C20.1323 20.9853 21.4315 19.6901 21.6091 17.4317C21.6339 17.1165 21.6339 6.88371 21.6083 6.56211C21.4195 4.15651 19.9387 2.77011 17.9875 2.48931C17.5403 2.42451 17.4507 2.40531 15.1563 2.40131C7.01793 2.40531 5.23393 2.04291 3.62833 3.70771Z",
              fill: "#3A3F48",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M12.0268 4.9126C9.12202 4.9126 6.36362 4.6542 5.31002 7.3582C4.87482 8.475 4.93802 9.9254 4.93802 12.0022C4.93802 13.8246 4.87962 15.5374 5.31002 16.6454C6.36122 19.351 9.14202 19.0918 12.0252 19.0918C14.8068 19.0918 17.6748 19.3814 18.7412 16.6454C19.1772 15.5174 19.1132 14.0886 19.1132 12.0022C19.1132 9.2326 19.266 7.4446 17.9228 6.1022C16.5628 4.7422 14.7236 4.9126 12.0236 4.9126H12.0268ZM11.3916 6.1902C17.4508 6.1806 18.222 5.507 17.7964 14.8646C17.6452 18.1742 15.1252 17.811 12.0276 17.811C6.37962 17.811 6.21722 17.6494 6.21722 11.999C6.21722 6.283 6.66522 6.1934 11.3916 6.1886V6.1902ZM15.8108 7.367C15.3412 7.367 14.9604 7.7478 14.9604 8.2174C14.9604 8.687 15.3412 9.0678 15.8108 9.0678C16.2804 9.0678 16.6612 8.687 16.6612 8.2174C16.6612 7.7478 16.2804 7.367 15.8108 7.367ZM12.0268 8.3614C10.0164 8.3614 8.38682 9.9918 8.38682 12.0022C8.38682 14.0126 10.0164 15.6422 12.0268 15.6422C14.0372 15.6422 15.666 14.0126 15.666 12.0022C15.666 9.9918 14.0372 8.3614 12.0268 8.3614ZM12.0268 9.639C15.1508 9.639 15.1548 14.3654 12.0268 14.3654C8.90362 14.3654 8.89882 9.639 12.0268 9.639Z",
          fill: "white",
        },
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear_1954_4435",
                x1: "3.66515",
                y1: "20.375",
                x2: "21.5095",
                y2: "4.93089",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#FFDD55" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "0.5", "stop-color": "#FF543E" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#C837AB" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }